import { render, staticRenderFns } from "./PerfilTrocarSenha.vue?vue&type=template&id=5e75dcf2"
import script from "./PerfilTrocarSenha.vue?vue&type=script&lang=js"
export * from "./PerfilTrocarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports